import * as React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FaExclamationTriangle } from 'react-icons/fa';

interface ConfirmModalProps {
    isOpen: boolean;
    toggle: () => void;
    onConfirm: () => void;
    title?: string;
    message?: string;
    confirmText?: string;
    confirmColor?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ 
    isOpen, toggle, onConfirm, 
    title = "Confirm Action", 
    message = "Are you sure you want to proceed?", 
    confirmText = "Confirm", 
    confirmColor = "danger" 
}) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered className="border-0">
            <ModalHeader toggle={toggle} className="bg-light border-bottom-0">
                <span className="fw-bold text-dark">{title}</span>
            </ModalHeader>
            <ModalBody className="text-center py-4">
                <div className={`text-${confirmColor} mb-3`}>
                    <FaExclamationTriangle size={40} />
                </div>
                <h5 className="fw-bold">Are you sure?</h5>
                <p className="text-muted mb-0">{message}</p>
            </ModalBody>
            <ModalFooter className="border-top-0 justify-content-center pb-4">
                <div className="d-flex justify-content-center gap-3 w-100 px-4">
                    <Button 
                        color="secondary" 
                        outline 
                        className="fw-bold shadow-sm flex-grow-1" 
                        style={{ whiteSpace: 'nowrap', maxWidth: '200px' }}
                        onClick={toggle}
                    >
                        Cancel
                    </Button>
                    <Button 
                        color={confirmColor} 
                        className="fw-bold shadow-sm text-white flex-grow-1" 
                        // whiteSpace: 'nowrap' prevents the text from wrapping
                        // minWidth: 'fit-content' ensures the button expands to the text
                        style={{ whiteSpace: 'nowrap', minWidth: 'fit-content', maxWidth: '200px' }}
                        onClick={() => { onConfirm(); toggle(); }}
                    >
                        {confirmText}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    );
};

export default ConfirmModal;